import React from "react"
import {formatTextTestIds} from "@next/utils"
import {
    SalePrice,
    WasPrice,
    DesktopWidth,
    MobileWidth,
    FromPrice,
    RectangleDivider,
    Spacer,
    StarRatingWrapper,
} from "../../components"
import {TextModel} from "../../../../models/Text"
import StarRatingContainer from "../../../starRatingContainer"

interface PriceStandardProps {
    price: string
    salePrice?: string | null
    wasPrice?: string | null
    text: TextModel
    colourwaysHasSale: boolean
    brandNameEnabled: boolean
    isMade2Measure: boolean
    minPrice?: string | undefined
    productPriceAriaLabelText: string
    isWasPriceARange: boolean
    enableReviewStars: boolean
    isPriceARange: boolean
    overallStarRating: number
    colourwaysHasStarRatingWithRangedPrice: boolean
    brandedMarkdownSalePrice: boolean
}

export const PriceStandard = ({
    price,
    salePrice,
    wasPrice,
    text,
    colourwaysHasSale,
    brandNameEnabled,
    isMade2Measure,
    minPrice,
    productPriceAriaLabelText,
    isWasPriceARange,
    enableReviewStars,
    isPriceARange,
    overallStarRating,
    colourwaysHasStarRatingWithRangedPrice,
    brandedMarkdownSalePrice,
}: PriceStandardProps) => {
    const wasPriceText = `${text.price.was} ${wasPrice}`
    const salePriceText = `${text.price.now} ${salePrice}`
    const wasPriceTextMobile = `${text.price.mobileWas} ${wasPrice}`
    const salePriceTextMobile = `${text.price.mobileNow} ${salePrice}`

    return (
        <>
            {brandNameEnabled && <RectangleDivider />}

            {!isMade2Measure && (
                <div aria-label={productPriceAriaLabelText}>
                    <DesktopWidth>
                        <WasPrice
                            data-testid={formatTextTestIds("product_summary_was_price")}
                            $brandNameEnabled={brandNameEnabled}
                            className={salePrice ? "prod-sum-price-line-through" : ""}
                        >
                            <span>{salePrice ? wasPriceText : price}</span>
                            <Spacer />
                            {!(isWasPriceARange || isPriceARange || colourwaysHasStarRatingWithRangedPrice) &&
                                enableReviewStars &&
                                overallStarRating > 0 && <StarRatingContainer />}
                        </WasPrice>
                        {colourwaysHasSale && (
                            <SalePrice
                                data-testid={formatTextTestIds("product_summary_sale_price")}
                                $brandNameEnabled={brandNameEnabled}
                                $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                                component="div"
                            >
                                {salePrice ? salePriceText : <wbr />}
                            </SalePrice>
                        )}
                    </DesktopWidth>
                    <MobileWidth>
                        <WasPrice
                            data-testid={formatTextTestIds("product_summary_was_price")}
                            $brandNameEnabled={brandNameEnabled}
                            className={salePrice ? "prod-sum-price-line-through" : ""}
                        >
                            <span>{wasPrice ? wasPriceTextMobile : price}</span>
                            <Spacer />
                            {!(isWasPriceARange || isPriceARange || colourwaysHasStarRatingWithRangedPrice) &&
                                enableReviewStars &&
                                overallStarRating > 0 && <StarRatingContainer />}
                        </WasPrice>
                        {colourwaysHasSale && (
                            <SalePrice
                                data-testid={formatTextTestIds("product_summary_sale_price")}
                                $brandNameEnabled={brandNameEnabled}
                                $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                                component="div"
                            >
                                {salePrice ? salePriceTextMobile : ""}
                            </SalePrice>
                        )}
                    </MobileWidth>
                </div>
            )}

            {isMade2Measure && (
                <FromPrice data-testid={formatTextTestIds("product_summary_from_price")}>
                    <span>{`${text.price.from} ${minPrice}`}</span>
                    {enableReviewStars && overallStarRating > 0 && (
                        <>
                            <Spacer />
                            <StarRatingWrapper>
                                <StarRatingContainer />
                            </StarRatingWrapper>
                        </>
                    )}
                </FromPrice>
            )}

            {colourwaysHasStarRatingWithRangedPrice && enableReviewStars && (
                <StarRatingWrapper>
                    <StarRatingContainer />
                </StarRatingWrapper>
            )}
        </>
    )
}
export default PriceStandard
